module.exports = __webpack_public_path__ + "img/reward-bubble-3.65cd2f75.png";